import {PopupId} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {observable} from 'mobx';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

export class ADialogState
{
    constructor(isVisible:boolean = false, isModal:boolean = false, hasModalBackground:boolean = true, ignoreEsc:boolean = false)
    {
        this.isVisible = isVisible;
        this.isModal = isModal;
        this.hasModalBackground = hasModalBackground;
        this.ignoreEsc = ignoreEsc;
    }

    @observable
    isVisible:boolean;

    @observable
    isModal:boolean;

    @observable
    ignoreEsc:boolean;

    @observable
    popupId:PopupId = `dialogPopupId-` + IdUtil.newComponentId();

    hasModalBackground:boolean;

    currentProps:any = null;
}

export class DialogsState
{
    @observable
    addSpace:ADialogState = new ADialogState();

    @observable
    addDesign:ADialogState = new ADialogState();

    @observable
    addOrganization:ADialogState = new ADialogState();

    @observable
    confirm:ADialogState = new ADialogState(false);

    @observable
    loginForm:ADialogState = new ADialogState(false, true, false, true);

    @observable
    signupForm:ADialogState = new ADialogState(false, true, false, true);

    @observable
    joinForm:ADialogState = new ADialogState(false, true, false, true);

    @observable
    resetPasswordForm:ADialogState = new ADialogState(false, true, false, true);

    @observable
    newPasswordForm:ADialogState = new ADialogState(false, true, false, true);

    @observable
    productSelection:ADialogState = new ADialogState(false);

    @observable
    creditCardEntry:ADialogState = new ADialogState(false);

    @observable
    visualDesignerProgress:ADialogState = new ADialogState(false);

    @observable
    publish:ADialogState = new ADialogState(false);

    @observable
    publishConfirmUrlChange:ADialogState = new ADialogState(false);

    @observable
    textInput:ADialogState = new ADialogState(false);

    @observable
    editProfile:ADialogState = new ADialogState(false);

    @observable
    invoiceDetails:ADialogState = new ADialogState(false);

    @observable
    flowRunWithParameters:ADialogState = new ADialogState(false);

    @observable
    clipboardHint:ADialogState = new ADialogState();

    @observable
    importTabs:ADialogState = new ADialogState(false, true, true, true);

    @observable
    delete:ADialogState = new ADialogState(false);

    @observable
    rename:ADialogState = new ADialogState(false);

    @observable
    nameCurrentVersion:ADialogState = new ADialogState(false);

    @observable
    emailVerification:ADialogState = new ADialogState(false, true, true, true);
}
